<template>
	<div class="pagination">
		<a class="back" @click="arrowHandler('back')"><span></span></a>
		<ul class="page_list">
			<template v-for="pageNo in pageNos" :key="pageNo">
				<li v-if="curPage === pageNo" class="current">{{ pageNo }}</li>
				<li v-else @click="pageHandler(pageNo)">{{ pageNo }}</li>
			</template>
		</ul>
		<a class="next" @click="arrowHandler('next')">
			<span></span>
		</a>
	</div>
</template>

<script>
import PageHandler from '@/common/page-handler';
import { isMobile } from '@/common/mobile';
export default {
	name: 'Pagination',
	props: {
		totalCount: {
			type: Number,
			default: 0,
		},
		totalPage: {
			type: Number,
			default: 0,
		},
		curPage: {
			type: Number,
			default: 0,
		},
		pageCount: {
			type: Number,
			default: isMobile() ? 5 : 10,
		},
		point: {
			type: Number,
			default: 0,
		},
		firstPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
	},
	computed: {
		pageNavigation: function () {
			return new PageHandler(
				this.totalCount,
				this.totalPage || 1,
				this.curPage,
				this.pageCount,
			);
		},
		pageNos: function () {
			const pageNos = [];
			let pageNo = null;

			// eslint-disable-next-line no-cond-assign
			while ((pageNo = this.pageNavigation.getNextPage())) {
				pageNos.push(pageNo);
			}

			return pageNos;
		},
	},
	methods: {
		pageHandler(pageNo) {
			this.$emit('change', pageNo);
			window.scrollTo(0, 0);
		},
		arrowHandler(direction) {
			if (direction === 'back') {
				if (this.curPage === this.firstPage) return;
				this.$emit('change', this.curPage - 1);
			} else {
				if (this.curPage === this.lastPage) return;
				this.$emit('change', this.curPage + 1);
			}
			window.scrollTo(0, 0);
		},
	},
};
</script>

<style scoped></style>
